import { QueueShortInfoRemoteDto } from 'src/generated/swagger';

export class OutBoundSkillShortInfoChanged {
   public static readonly type = '[Samwin Outbound Skill ShortInfo] outbound skill shortinfo changed';

   constructor(public outBoundSkillShortInfo: Array<QueueShortInfoRemoteDto>) {}
}
